"use client";

import { Printer } from "lucide-react";

/**
 * Tiny client-only button that triggers window.print(). Extracted into
 * its own file so the parent page can stay a server component.
 */
export function PrintButton() {
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="inline-flex items-center gap-2 rounded-full border border-ink-200 bg-white px-4 py-2 text-sm font-medium text-ink-700 transition hover:bg-cream-100 print:hidden"
    >
      <Printer className="h-4 w-4" aria-hidden />
      Imprimir / guardar como PDF
    </button>
  );
}
